import { Theme } from "@mui/material";

export const getAppBarColor = (env: string, theme: Theme) => {
  if (env.includes("pre-staging")) return "#8A2BE2";
  if (env.includes("staging")) return theme.palette.success.main;
  if (env.includes("qa")) return theme.palette.error.main;
  return theme.palette.grey[900];
};